import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { APP_ROUTES as ROUTES } from '@app/app.routes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentStateGuard implements CanActivate {
  constructor(private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const queryParams = route.queryParams;

    if (queryParams['transaction_id'] && queryParams['external_id'] && queryParams['status']) {
      return true;
    } else {
      return this._router.createUrlTree([ROUTES.ERROR]);
    }
  }
}
